"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.previousOrders = void 0;
var utils_1 = require("../../utils");
var PREVIOUS_ORDER_BASE_URL = '/previous-orders';
exports.previousOrders = function (axios) {
    return {
        getPreviousOrders: function (request) {
            return axios.get('/previous-orders', request);
        },
        getPreviousOrdersMalls: function () {
            return axios.get('/previous-orders/malls');
        },
        getPreviousOrdersOrderNo: function (request) {
            var url = utils_1.paramPathchange('/previous-orders/{orderNo}', request);
            return axios.get(url, request.data);
        },
        putPreviousOrdersOrderNoAdminMemos: function (request) {
            var url = utils_1.paramPathchange('/previous-orders/{orderNo}/admin-memos', request);
            return axios.put(url, request.data);
        },
        deletePreviousOrdersOrderNoAdminMemosMemoNo: function (request) {
            var url = utils_1.paramPathchange('/previous-orders/{orderNo}/admin-memos/{memoNo}', request);
            return axios.delete(url, request.data);
        },
        putPreviousOrdersOrderNoTemporaryPassword: function (request) {
            var url = utils_1.paramPathchange(PREVIOUS_ORDER_BASE_URL + "/{orderNo}/temporary-password", request);
            return axios.put(url);
        }
    };
};
